import React from 'react';
import PropTypes from 'prop-types';

class Caption extends React.PureComponent {
  render() {
    return (
      <div
        className={`col-lg-4 col-md-4 col-sm-6 ${this.props.animate
          ? 'wow fadeInUp delay-03s'
          : ''}`}
      >
        <div className={`recent-properties-box ${this.props.horizontal && 'horizontal'}`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Caption.propTypes = {
  children: PropTypes.node,
  animate: PropTypes.string,
  horizontal: PropTypes.bool,
};

Caption.defaultProps = {
  children: undefined,
  animate: undefined,
  horizontal: false,
};

export default Caption;



// WEBPACK FOOTER //
// ./src/components/Caption/Caption.js